import * as React from 'react';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { SvgIcon, useTheme } from '@mui/material';

export default function TollRoadIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon {...props} htmlColor={color} viewBox="0 0 37 36">
      <path
        d="M29.9 14.3H7.1c-.4.2-.7.8-.7.8l-.8 3.8H2.8v-3.1c0-1.5-.9-1.5-.9-1.5h-.2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h33.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H35s-.9.1-.9 1.5v3.1h-2.8l-.8-3.8c.1 0-.3-.7-.6-.8zM16.6 9.2h-4.9l1.4-7.1c.2-.9 1.1-1.6 2-1.6h1.7l-.2 8.7zm-.2 7.3l-.6 18.6H8.1c-.9 0-1.5-.7-1.3-1.6l3.5-17h6.1zm9-7.3h-4.9L20.2.5h1.7c.9 0 1.8.7 2 1.6l1.5 7.1zm1.5 7.3l3.5 17c.2.9-.4 1.6-1.3 1.6h-7.7l-.6-18.6h6.1z"
        opacity={0.3}
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0a4842"
      />
    </SvgIcon>
  );
}
